'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Seasonality.SeasonalityReviewConstants', []).constant('PooledSeasonalityReviewConstants', {
  DEFAULT_PAGE_LIMIT: 10000,
  SYSTEM_USER: 'AVRO',
  PROFILE_STATUS_PUBLISHED: 'PUBLISHED',
  FEATURE_MAPPED_MODE: 'MAPPED_MODE',
  QUEUE_ELEMENTS: 'queueElements',
  CARRIER: 'carrier',
  SCREEN_ID_SEASONALITY: 'Seasonality',
  SCREEN_ID_MARKET_ANALYSIS: 'Market Analysis',
  DEFAULT_RTPS: 'POOLED_SEASONALITY_REVIEW_RTPS',
  DOW_GROUP_ALL: 'All',
  WOY_53: 53,
  EVENT_TYPE: {
    EXCLUDED: 'Excluded',
    OUTLIER: 'Outlier',
    NO_EVENT: 'normal'
  },
  COLOR_THEME: {
    FILL_DARK: '#376092',
    FILL_LIGHT: '#6FA8DC'
  },
  ENDPOINT_URL: {
    HEP_ALL_URL: 'configuration/hep/all?type=',
    HEP_URL: 'configuration/hep?type=',
    PUBLISH: 'pooled/seasonality/publish',
    FLATTENED_DEMAND: 'domain/demand/flattenedExtendedUntruncatedMarketDemand',
    SAVE_OUTLIERS: 'ancillary/marketSeasonAndOutlier/bulk',
    GET_OUTLIERS: 'ancillary/marketSeasonAndOutlier',
    GET_CALENDAR: 'pooled/seasonality/analysis',
    HEP_CALENDAR_NAME_URL: 'pooled/seasonality/profiles?type=',
    HEP_SIMPLE: 'configuration/hepSimple/'
  },
  INDEX_ANALYSIS: {
    LABEL: 'Seasonality Index Analysis',
    VALUE: 'seasonality-indexes-chart'
  },
  SEASON_LABELS: {
    LABEL: 'Season Labels',
    VALUE: 'seasonality-labels-chart'
  },
  FLOW_TYPE: {
    REGULAR: 'Regular',
    MAPPED: 'Mapped'
  },
  PROFILE_TYPE: {
    INDEX: 'Index',
    DEMAND: 'Demand'
  },
  HEP: {
    MAPPED_INDEX_PROFILE: 'MappedMarketPooledSeasonalityIndexesProfile',
    MAPPED_DEMAND_PROFILE: 'MappedMarketPooledSeasonalityDemandProfile',
    REGULAR_INDEX_PROFILE: 'RegularMarketPooledSeasonalityIndexesProfile',
    REGULAR_DEMAND_PROFILE: 'RegularMarketPooledSeasonalityDemandProfile',
    RTP: 'RTP'
  },
  RSQL_OPERATORS: {
    SINGLE: '==',
    MULTI: '=in=',
    GREATER_THAN: '=ge=',
    LESSER_THAN: '=le='
  },
  DOW_GROUPS: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
  DOW_DISPLAY_TO_USAGE: {
    Mon: 'M',
    Tue: 'T',
    Wed: 'W',
    Thu: 'Th',
    Fri: 'F',
    Sat: 'Sa',
    Sun: 'Su'
  },
  DAY_OF_WEEK_MAPPING: {
    Mon: 1,
    Tue: 2,
    Wed: 3,
    Thu: 4,
    Fri: 5,
    Sat: 6,
    Sun: 0
  },
  OUTLIER_PARTITION_SIZE: 100,
  OUTLIER_SAVE_OPTIONS: {
    ALL: 'ALL',
    SELECTED: 'SELECTED'
  },
  OUTLIER_MENU: [{
    label: 'All Cabins',
    value: 'ALL'
  }, {
    label: 'Selected Cabin',
    value: 'SELECTED',
    selected: true
  }]
});